import * as React from 'react';
import * as styles from './Account.css';
import { Button } from '../Button';
import { ArrowIcon } from '../../ArrowIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Account = function Account(_ref) {
  var loading = _ref.loading,
    disabled = _ref.disabled,
    onClick = _ref.onClick,
    title = _ref.title;
  var handleClick = React.useCallback(function () {
    return onClick();
  }, [onClick]);
  return /*#__PURE__*/_jsx("div", {
    className: styles['account'],
    children: /*#__PURE__*/_jsx(Button, {
      disabled: loading || disabled,
      loading: loading,
      onClick: handleClick,
      children: /*#__PURE__*/_jsxs("span", {
        className: styles['account-content'],
        children: [/*#__PURE__*/_jsx("span", {
          className: styles['account-title'],
          children: title
        }), !disabled && /*#__PURE__*/_jsx("span", {
          className: styles['account-icon'],
          "data-testid": "account-icon",
          children: /*#__PURE__*/_jsx(ArrowIcon, {})
        })]
      })
    })
  });
};
Account.displayName = 'Account';